import type { FC } from 'react';
import { XIcon } from '@heroicons/react/outline';
import type { SubmissionShort } from '@queries/fetchSubmissions';

interface SelectedContractRowProps {
  contract: SubmissionShort;
  onRemove: (contractId: string) => void;
}

export const SelectedContractRow: FC<SelectedContractRowProps> = ({ contract, onRemove }) => {
  return (
    <div className="group hover:bg-info-100 flex w-full min-w-0 items-center justify-between gap-2 rounded-sm px-2 py-1.5">
      <p className="min-w-0 flex-1 truncate pr-1 text-sm leading-5 font-normal text-gray-700">{contract.name}</p>
      <button
        type="button"
        onClick={() => onRemove(contract.id)}
        className="text-info-400 hover:text-info-700 flex h-5 w-5 shrink-0 items-center justify-center opacity-0 transition-opacity group-hover:opacity-100"
        aria-label={`Remove ${contract.name}`}
      >
        <XIcon className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
